/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://suuoj3cvljch3iex45aqw3s5t4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-v3mu2iinpzgkrncldi26c4m7xa",
    "aws_cognito_identity_pool_id": "us-east-1:e10bc023-6f77-4599-bcb8-d849ea52b381",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_UaA4dDiEf",
    "aws_user_pools_web_client_id": "4lr0nvu9pp2700ikpvbqsfkmm2",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "amplifyreactgraphql03f86630e74c43e7a10b7f51cee3224619-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
